import {API, Auth} from "aws-amplify";
import {API_NAME} from "../config/aws-exports";

function getUserAccessToken() {
  return Auth.currentSession()
    .then(res => {
      const accessToken = res.getAccessToken()
      const jwt = accessToken.getJwtToken();
      return new Promise(resolve => {
        resolve(jwt);
      });
    })
}

const CLOUDFRONT_URL_MAPPINGS = {
  'myeduplus-assets.s3.eu-south-1.amazonaws.com': 'prod.files.myedu.it',
  'myeduplus-assets.amazonaws.com': 'prod.files.myedu.it',
  'myedu-assets-dev.s3.eu-south-1.amazonaws.com': 'dev.files.myedu.it',
  'myedu-assets-dev.s3.amazonaws.com': 'dev.files.myedu.it',

  'myeduplus.s3.eu-west-2.amazonaws.com': 'prod.media.myedu.it',
  'myeduplus.s3.amazonaws.com': 'prod.media.myedu.it',
  'myeduplus-school.s3.eu-west-2.amazonaws.com': 'dev.media.myedu.it',
  'myeduplus-school.s3.amazonaws.com': 'dev.media.myedu.it',
  'myeduplus-test.s3.eu-west-2.amazonaws.com': 'test.media.myedu.it',
  'myeduplus-test.s3.amazonaws.com': 'test.media.myedu.it',
};


function replaceWithCloudFrontUrl(response) {
  const responseJson = JSON.stringify(response);

  const mappedResponseJson = Object.keys(CLOUDFRONT_URL_MAPPINGS).reduce((acc, bucketName) => {
    const cloudFrontUrl = CLOUDFRONT_URL_MAPPINGS[bucketName];

    if (acc.includes(bucketName)) {
      return acc.replaceAll(bucketName, cloudFrontUrl)
    }

    return acc;
  }, responseJson)

  return new Promise((resolve) => {
    resolve(JSON.parse(mappedResponseJson))
  })
}

export function register(fields) {
  const body = {
    ...fields,
    cognito_client_id: process.env.REACT_APP_AWS_AUTH_USER_POOL_WEBCLIENT_ID
  }

  return fetch(`${process.env.REACT_APP_API_BASE_URL}/register`, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {}
  })
    .then(res => res.json());
}

export function getCourses() {
  return API.get(API_NAME, "/courses")
    .then(replaceWithCloudFrontUrl)
}

export function getCourse(id) {
  return API.get(API_NAME, `/courses/${id}`)
    .then(replaceWithCloudFrontUrl)
}

export function getLesson(id) {
  return API.get(API_NAME, `/lessons/${id}`)
    .then(replaceWithCloudFrontUrl)
}

export function getTopic(id) {
  return API.get(API_NAME, `/topics/${id}`)
    .then(replaceWithCloudFrontUrl)
}

export function getUser() {
  return getUserAccessToken()
    .then(
      accessToken =>
        API.get(API_NAME, "/user", {
          headers: {
            'myedu-coaching-access-token': accessToken,
          }
        })
    );
}

export function updateUserAttributes(userAttributes) {
  return getUserAccessToken()
    .then(
      accessToken =>
        API.put(API_NAME, "/user", {
          body: {
            'user_attributes': userAttributes,
          },
          headers: {
            'myedu-coaching-access-token': accessToken,
          }
        })
    );
}